import { Sparkles } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface CaptureFabProps {
  onOpen?: () => void;
}

export default function CaptureFab({ onOpen }: CaptureFabProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="Nouvelle capture (N)"
            data-testid="button-open-capture"
            onClick={onOpen}
            style={{
              position: "fixed",
              right: "1rem",
              bottom: "1rem",
              zIndex: 40,
            }}
            className="w-14 h-14 rounded-full shadow-xl bg-primary text-primary-foreground flex items-center justify-center md:right-8 md:bottom-8 hover:bg-primary/90 active:scale-95 transition-all"
          >
            <Sparkles className="w-6 h-6" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="left" className="font-medium">
          Nouvelle capture <kbd className="ml-1.5 text-[10px] border border-current/30 rounded px-1 py-0.5">N</kbd>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
